import { render, staticRenderFns } from "./EditTimeBasedSubchannel.vue?vue&type=template&id=45a1983f&"
import script from "./EditTimeBasedSubchannel.vue?vue&type=script&lang=js&"
export * from "./EditTimeBasedSubchannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports